import { Grid2, IconButton, TableCell, Typography } from "@mui/material";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import countries from "world-countries";
import * as Yup from "yup";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import EyeIco from "../../../../assets/icons/EyeIco";
import CommonButton from "../../../../component/Button";
import SnackBar from "../../../../component/SnackBar";
import {
  ClientDelete,
  ClientTableGetCall,
} from "../../../../redux/action/ClientPartner";
import { JobIndustryList } from "../../../../redux/action/Job";
import { CreateNewRelationshipCall } from "../../../../redux/action/VendorPartner";
import CommonTable from "../../../candidates/Table";
import { CustomDiv } from "../../../chat-bot/style";
import SkillDeleteDialog from "../../../common-components/DeleteDialog";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../../common-components/StyledComponents";
import CreateRecord from "../crm-view/components/CreateRecord";
import RatingStarIco from "../../../../assets/icons/RatingStarIco";
import parsePhoneNumber from "libphonenumber-js";

export default function Client() {
  const navigate = useNavigate();
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
    id: "",
  });
  const [clientList, setClientList] = useState({
    data: [],
    currentPage: 1,
    totalPage: "",
    loading: true,
  });
  const [deleteButton, setDeleteButton] = useState({
    loading: false,
    open: false,
    content: "",
    id: "",
  });
  const [contact, setContact] = useState({
    open: false,
    disabled: false,
    createLoading: false,
    cancelLoading: false,
  });
  const [initialValues, setInitialValues] = useState({
    name: "",
    country: "",
    country_data: countries.map((country) => {
      return {
        name: `${country.name.common}`,
      };
    }),
    email: "",
    industry: "",
    available_industry: [],
    primary_time_zone: "",
    primary_time_zone_data: [
      { name: "Eastern Standard Time(EST)" },
      { name: "Central Standard Time(CST)" },
      { name: "Mountain Standard Time(MST)" },
      { name: "Pacific Standard Time(PST)" },
      { name: "Indian Standard Time(IST)" },
      { name: "Gulf Standard Time(GST)" },
      { name: "Greenwich Standard Time(GST)" },
    ],
    website: "",
    contact_number: "",
    currency_status: "",
    currency_status_data: [
      { id: "0", name: "Dollar (USD)" },
      { id: "1", name: "Euro (EUR)" },
      { id: "2", name: "Rupee (INR)" },
    ],
    vms: "",
    hub_cities: "",
    hub_cities_value: "",
    loading: false,
    rating: 0,
  });
  const contactData = [
    {
      title: "Business Name",
      component: "input",
      titleName: "name",
      placeholder: "Enter the Name",
      placeholderFontSize: "15px",
      mandatory: true,
    },
    {
      title: "Hub Cities",
      component: "autoComplete",
      titleName: "hub_cities",
      placeholder: "Enter Cities",
      inputValue: "hub_cities_value",
      mandatory: true,
    },
    {
      title: "Country",
      component: "single-auto-complete",
      titleName: "country",
      placeholder: "Select the Country",
      dropDownData: "country_data",
      placeholderFontSize: "15px",
      mandatory: true,
    },
    {
      title: "Email Address",
      component: "input",
      titleName: "email",
      placeholder: "Enter the Email Address",
      placeholderFontSize: "15px",
      mandatory: true,
    },
    {
      title: "VMS",
      component: "input",
      titleName: "vms",
      placeholder: "Enter VMS",
      placeholderFontSize: "15px",
      mandatory: false,
    },
    {
      title: "Primary Time Zone",
      component: "dropDown",
      titleName: "primary_time_zone",
      dropDownData: "primary_time_zone_data",
      placeholder: "Select Time Zone",
      mandatory: true,
    },

    {
      title: "Website",
      component: "input",
      titleName: "website",
      placeholder: "Enter the Website",
      placeholderFontSize: "15px",
      mandatory: true,
    },

    {
      title: "Mobile Number",
      component: "phone-number",
      fontSize: "15px",
      country: "phone_country",
      titleName: "contact_number",
      placeholder: "Enter the Mobile Number",
      placeholderFontSize: "15px",
      mandatory: false,
    },

    // {
    //   title: "Mobile Number",
    //   component: "input",
    //   titleName: "contact_number",
    //   placeholder: "Enter the Mobile Number",
    //   placeholderFontSize: "15px",
    //   mandatory: false,
    // },
    {
      title: "Industry",
      component: "multi-complete",
      titleName: "industry",
      options: "available_industry",
      placeholder: "Select the Industry",
      valueChange: true,
      mandatory: true,
    },
    {
      title: "Currency",
      component: "multi-complete",
      titleName: "currency_status",
      options: "currency_status_data",
      placeholder: "Select the Currency",
      valueChange: true,
      mandatory: true,
    },
    {
      title: "Rating",
      component: "slider",
      titleName: "rating",
      placeholderFontSize: "15px",
      mandatory: false,
    },
  ];

  const [headerData, setHeaderData] = useState([
    { name: "Unique Id", direction: "asc", sort: false },
    { name: "Name", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    { name: "Rating", direction: "asc", sort: false },
    { name: "Onboarded", direction: "asc", sort: false },
    {},
  ]);

  const handleAddClientClick = async () => {
    setContact((prev) => ({
      ...prev,
      open: true,
    }));
    setInitialValues((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const listData = await JobIndustryList();
      setInitialValues((prev) => ({
        ...prev,
        available_industry: listData || [],
        loading: false,
      }));
    } catch (error) {
      setInitialValues((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
    // navigate(`/client/add`);
  };

  const handleViewClick = (list) => {
    navigate(
      `/relationship-intelligence-view?type=Client&title=${list.client_name}&id=${list.id}`
    );
  };

  const handleClientTableBodyData = (row, index) => {
    return (
      <Fragment>
        <TableCell>{row.order_no}</TableCell>
        <TableCell>{row.client_name || "-"}</TableCell>
        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Inactive"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>
          <CommonGrid2
            display={"flex"}
            gap={"3px"}
            borderRadius={"50px"}
            padding={"2px 7px 2px 6px"}
            alignItems={"center"}
            width={"max-content"}
            background={
              row.rating > 4
                ? "#36A41D"
                : row.rating > 2.5
                ? "#F79009"
                : "#FF5C77"
            }
          >
            <RatingStarIco />
            <Typography
              variant="p"
              color="#fff"
              fontWeight={600}
              fontSize={"13px"}
            >
              {row.rating}
            </Typography>
          </CommonGrid2>
        </TableCell>
        <TableCell>
          {row.created_at ? moment(row.created_at).format("DD MMM YYYY") : "-"}
        </TableCell>
        <TableCell>
          <CommonGrid2 display={"flex"} gap={"10px"} justifyContent={"end"}>
            <IconButton onClick={() => handleViewClick(row)}>
              <EyeIco />
            </IconButton>
            <IconButton onClick={(e) => handleDeleteClick(e, row)}>
              <DeleteIco />
            </IconButton>
          </CommonGrid2>
        </TableCell>
      </Fragment>
    );
  };

  const handleDeleteClick = (e, list) => {
    e.stopPropagation();
    e.stopPropagation();
    setDeleteButton((prev) => ({
      ...prev,
      open: true,
      content: list.client_name,
      id: list.id,
    }));
  };

  const handelDialogClose = () => {
    setDeleteButton({
      open: false,
      loading: false,
      content: "",
      id: "",
    });
  };

  const handleClientDelete = async () => {
    setDeleteButton((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const data = await ClientDelete(deleteButton.id);
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      handleFetchClientCall();
      handelDialogClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setDeleteButton((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleFetchClientCall = async () => {
    try {
      setClientList((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await ClientTableGetCall();
      setClientList((prev) => ({
        ...prev,
        data: data?.data,
        loading: false,
      }));
    } catch (error) {
      setClientList((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    handleFetchClientCall();
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleButttonClose = () => {
    setContact((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      createLoading: false,
      cancelLoading: false,
    }));
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    country: Yup.string().required("Country is required"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      ),
    primary_time_zone: Yup.string().required("Time Zone is required"),
    website: Yup.string().required("Website is required"),
    contact_number: Yup.string()
      .nullable()
      .test(
        "match-country",
        "Selected phone country does not match the user's country",
        function (value) {
          const { phone_country, country } = this.parent;

          if (!value) return true; // optional field
          if (!phone_country || !phone_country.name) return true;

          // Check: phone_country.name === country
          console.log(
            phone_country.name,
            country,
            "phone_country.name === country"
          );
          return phone_country.name === country;
        }
      )
      .test(
        "is-valid-phone",
        "Phone number is not valid for the selected country",
        function (value) {
          const { phone_country } = this.parent;

          if (!value) return true; // optional field
          if (!phone_country?.countryCode) return true;

          const formattedValue = value.startsWith("+") ? value : `+${value}`;

          const phoneNumber = parsePhoneNumber(
            formattedValue,
            phone_country.countryCode
          );

          return phoneNumber?.isValid();
        }
      ),

    // contact_number: Yup.string().required("Mobile Number is required"),
    currency_status: Yup.array()
      .min(1, "At least one currency is required")
      .required("Currency is required"),
    industry: Yup.array()
      .min(1, "At least one industry is required")
      .required("Industry is required"),
    // vms: Yup.string().required("VMS is required"),
    hub_cities: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          content: Yup.string().required("Cities name is required"),
        })
      )
      .min(1, "At least one cities is required")
      .test("unique-content", "Cities List must be unique", function (value) {
        if (!value || value.length === 0) return false;
        const contentSet = new Set();
        for (let location of value) {
          if (location.content) {
            const lowercasedContent = location.content.toLowerCase();
            if (contentSet.has(lowercasedContent)) {
              return false;
            }
            contentSet.add(lowercasedContent);
          }
        }
        return true;
      }),
  });

  const handleSubmit = async (values) => {
    try {
      setContact((prev) => ({
        ...prev,
        disabled: true,
        createLoading: true,
      }));
      let payload = {
        client_name: values.name,
        hub_cities: values?.hub_cities?.map((item) => item.content),
        country: values.country,
        email: values.email,
        vms: values.vms,
        primary_time_zone: values.primary_time_zone,
        website: values.website,
        contact_number: values.contact_number,
        industry: values?.industry?.map((item) => item.id),
        currency_status: values?.currency_status?.map((item) => item.name),
        rating: values.rating,
        notes: [],
      };
      const data = await CreateNewRelationshipCall("client", payload);
      handleFetchClientCall();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      handleButttonClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setContact((prev) => ({
        ...prev,
        disabled: false,
        createLoading: false,
      }));
    }
  };

  const handleContactClose = () => {
    setContact((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      handleButttonClose();
    }, 1000);
  };

  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <Grid2 container spacing={2} marginBottom={"2rem"}>
        <CommonGrid2
          size={{ xs: 12, md: 4, sm: 12 }}
          item
          alignItems={"center"}
          display={"flex"}
        >
          <Typography variant="h3">Clients</Typography>
        </CommonGrid2>
        <CommonGrid2
          item
          size={{ xs: 12, md: 8, sm: 12 }}
          gap="10px"
          display="flex"
          justifyContent={"end"}
        >
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="600"
            value="Add Clients"
            padding="8px 20px"
            onClick={handleAddClientClick}
          />
        </CommonGrid2>
      </Grid2>
      <CommonTable
        data={clientList.data}
        columns={headerData}
        loadingRowLength={5}
        onSortChange={(col) => console.log("Sort by", col)}
        handleTableBodyData={handleClientTableBodyData}
        withPagination={false}
        loading={clientList.loading}
        handleRowClick={handleViewClick}
        customStyle={{
          "& .MuiTableRow-root": {
            cursor: "pointer",
          },
          "& .MuiTableRow-head": {
            cursor: "auto",
          },
        }}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />

      <CreateRecord
        contact={contact}
        title={"Create New Client"}
        handleButttonClose={handleButttonClose}
        contactData={contactData}
        validationSchema={validationSchema}
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        handleContactClose={handleContactClose}
      />

      <SkillDeleteDialog
        deleteDialog={deleteButton.open}
        handleDeleteDialogClose={handelDialogClose}
        handleDeleteSkill={handleClientDelete}
        buttonLoading={deleteButton.loading}
        title="Clients"
        content={deleteButton.content}
      />
    </CustomDiv>
  );
}
